import IconUser from "@/app/(components)/generics/Icons/IconUser";
import IconUsers from "@/app/(components)/generics/Icons/IconUsers";
import { TKey } from "@/app/translations/TKey";
import { HomeAudience } from "@/app/types/home/HomeAudience";

export const HOME_AUDIENCES: HomeAudience[] = [
  {
    titleKey: TKey.HOME_WHO_1_TITLE,
    textKey: TKey.HOME_WHO_1_TEXT,
    answerKey: TKey.HOME_WHO_1_ANSWER,
    icon: <IconUser />,
  },
  {
    titleKey: TKey.HOME_WHO_3_TITLE,
    textKey: TKey.HOME_WHO_3_TEXT,
    answerKey: TKey.HOME_WHO_3_ANSWER,
    icon: <IconUsers />,
  },
];

export function renderMarked(text: string, className: string) {
  return text.split("**").map((part, index) =>
    index % 2 === 1 ? (
      <mark key={part} className={className}>
        {part}
      </mark>
    ) : (
      part
    ),
  );
}
